export const vClickOutSide = {
  mounted: (el, binding, vnode) => {
    const { id } = vnode.el;

    el.clickOutsideEvent = (event) => {
      const { target } = event;
      const targetId = target.id;

      if (!(el == target || el.contains(target) || targetId == id)) {
        binding.value(event, el);
      }
    };

    document.addEventListener('click', el.clickOutsideEvent);
  },
  unmounted: (el) => {
    document.removeEventListener('click', el.clickOutsideEvent);
  },
};

export default vClickOutSide;
